
import { Skeleton } from "@/components/ui/skeleton";

export const LoadingState = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12">
        <div className="flex flex-col space-y-8">
          <div className="flex flex-col space-y-4">
            <Skeleton className="h-12 w-3/4 rounded-md" />
            <Skeleton className="h-8 w-1/2 rounded-md" />
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 space-y-8">
              <div className="space-y-4">
                <Skeleton className="h-8 w-48" />
                <Skeleton className="h-32 w-full" />
              </div>
              
              <div className="space-y-4">
                <Skeleton className="h-8 w-48" />
                <div className="space-y-2">
                  {[1, 2, 3].map((i) => (
                    <Skeleton key={i} className="h-16 w-full" />
                  ))}
                </div>
              </div>
            </div>
            
            <div className="lg:col-span-1">
              <div className="sticky top-24">
                <Skeleton className="h-[400px] w-full rounded-md" />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
        <div className="animate-pulse text-primary">
          <div className="h-12 w-12 mx-auto border-4 border-t-transparent border-primary rounded-full animate-spin mb-4" />
          <p className="text-muted-foreground">Loading course content...</p>
        </div>
      </div>
    </div>
  );
};
